import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-error" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "sub-title" }

import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentErrorView',
  setup(__props) {

const back = () => {
  console.log(sessionStorage.getItem("previousRoute"));
  router.replace(sessionStorage.getItem("previousRoute") || "/");
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("err.occurred.title")), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("err.occurred.tip")), 1),
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: back
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("err.back")), 1)
      ]),
      _: 1
    })
  ]))
}
}

})